import Model from './Model';
import { DateRange } from 'moment-range';
import Practitioner from './Practitioner';
import Establishment from './Establishment';
import { ClassTransformOptions, plainToClass, Type } from 'class-transformer';

class Holiday extends Model {
    id: number;
    practitioner_id: number;
    establishment_id: number;
    label: string;
    @Type(() => Date)
    start: Date;
    @Type(() => Date)
    end: Date;
    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;

    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'Holiday';
    }

    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => Practitioner)
    practitioner: Practitioner;

    @Type(() => Establishment)
    establishment: Establishment;

    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    /**
     * @return {DateRange}
     */
    period(): DateRange {
        // @ts-ignore
        return moment().range(this.start, this.end) as DateRange;
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): Holiday[];
    static new(plain: {}, options?: ClassTransformOptions): Holiday;
    static new(plain: {} | [], options?: ClassTransformOptions): Holiday | Holiday[] {
        return plainToClass(Holiday, plain as any, options);
    }
}

export default Holiday;
